// extracted by css-extract-rspack-plugin
export default {"buttonsHorizontalWrapper":"buttons-horizontal-wrapper--CYnzzZbBWawBcy6I"};